/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * configuration type
 */
export enum ConfigurationType {
    INTERNAL = 'INTERNAL',
    EXTERNAL = 'EXTERNAL',
}
